import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPAccount } from './dp-account';
import { DPAccountService } from './dp-accounts.service';
import { Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { DPSubscriptionService } from './dp-subscriptions.service';
import { DPMarket } from './model/dp-market';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    templateUrl: 'dp-account-detail.component.html',
})
export class DPAccountDetailComponent implements OnInit {
    @Input() account: DPAccount;
    @Output() close = new EventEmitter();
    error: any;
    navigated = false; // true if navigated here
    errorResponse: any;
    success: any;
    storedStatus: number;
    isStatusFirst: any;
    foundIt: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    marketLists: DPMarket[];
    marketFilteredList: DPMarket[];
    query: string;
    selectedMarket: DPMarket;
    selectedAccountType: string;
    marketSearchSelected = false;
    submitting = false;
    accesstypes = ['internal', 'subscription', 'earlyaccess', 'churned', 'oneoff'];
    constructor(
        private toasterService: ToasterService,

        private subscriptionService: DPSubscriptionService,
        private _service: NotificationsService,
        private router: Router,
        private accountService: DPAccountService,
        private route: ActivatedRoute) {
    }
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    getMarkets() {
        return this.subscriptionService
            .getMarkets()
            .then(res => {
                this.marketLists = res.subscriptions.markets;
                this.query = this.marketLists[this.marketLists.findIndex(x => x.id == this.account.home_market)].displayName;
            })
            .catch(error => this.errorHandler(error));
    }
    filterMarket(term: string) {
        if (term !== '') {
            this.query = term;
            this.marketFilteredList = this.marketLists.filter(u => u.displayName.toLowerCase().includes(term.toLowerCase()));
        } else {
            this.marketFilteredList = [];
        }
    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }
    ngOnInit() {

        this.route.params.forEach((params: Params) => {
            const account_id = +params['account_id'];
            this.navigated = true;
            this.accountService.getAccount(account_id)
                .then(account => {
                    this.account = account;
                    this.selectedAccountType = this.account.account_type;
                    this.getMarkets();
                });
        });
        this.isStatusFirst = true;
        this.storedStatus = 0;




    }


    save1(account: DPAccount, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            this.submitting = true;
            //check role has been changed

            //check status has been changed
            if (this.isStatusFirst == false) {
                account.status = this.storedStatus;
            } else {
                account.status = this.account.status;
            }

            if (account.account_type === undefined) [
                account.account_type = 'internal'
            ];

            if (this.marketSearchSelected == false) {
                const searchIndex = this.marketLists.findIndex(x => x.displayName.toLowerCase() == this.query.toLowerCase());

                if (searchIndex > -1) {
                    account.home_market = this.marketLists[searchIndex].id;
                    account.customer = this.account.customer;
                    account.customer_id = this.account.customer.customer_id;
                    account.account_id = this.account.account_id;
                    account.account_type = this.selectedAccountType;

                    this.save(account);

                }

                else {
                    this.notificationType = 'error';
                    this.notificationTitle = 'Error';
                    this.submitting = false;
                    this.notificationContent = this.query + ' is not valid market';
                    this.createNotification();
                }
            } else {
                account.customer = this.account.customer;
                account.customer_id = this.account.customer.customer_id;
                account.account_id = this.account.account_id;
                account.home_market = this.selectedMarket.id;
                account.account_type = this.selectedAccountType;
                this.save(account);
            }

        }
    }

    save(account: DPAccount) {
        this.accountService
            .updateAccount(account)
            .then(customer => {
                this.account = account;
                this.goBack();
            })
            .catch(error => this.errorHandler(error));

    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account', this.account.customer.customer_id]);
        }
    }
    public activeStatus = [
        { value: 0, display: 'Inactive' },
        { value: 1, display: 'Active' },
    ];



    checkExistingStatus() {
        if (this.account.status == 1) {
            return true;
        }
        return false;
    }

    checkStatus() {
        if (this.isStatusFirst == true) {
            this.storedStatus = this.account.status;
            this.isStatusFirst = false;
        }

        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }

    selectMarket(market: DPMarket) {
        this.marketSearchSelected = true;
        this.query = market.displayName;
        this.selectedMarket = market;

    }

    handleBlur() {
        setTimeout(() => {
            this.marketFilteredList = [];
        }, 200);
    }

    checkExistingAccess(access: string) {
        if (access == this.selectedAccountType) {
            return true;
        }
        return false;
    }

    checkAccess(access: string) {
        this.selectedAccountType = access;
    }

}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-account-detail.component.ts